import { Record, List } from 'immutable';

export default class TaskRecord extends Record({
  id: null,
  content: null,
  createdAt: null,
  createdBy: null,
  completedAt: null,
  completedBy: null,
  assignee: null,
  dueAt: null,
  entity: undefined,
  links: new List(),
}) {
}
